export const DEFAULT_ZOOM_LVL = 1;
export const DEFAULT_HIGH_ZOOM_LVL = 2;
export const ZOOM_DELTA_LVL = 0.5;
